import AssessmentCell from '@app/src/components/Table/Cells/AssessmentCell'
import { AssessmentTrendCell } from '@app/src/components/Table/Cells/AssessmentTrendCell'
import ChipCell from '@app/src/components/Table/Cells/ChipCell'
import CompanyCell from '@app/src/components/Table/Cells/CompanyCell'
import CountryCell from '@app/src/components/Table/Cells/CountryCell'
import DateCell from '@app/src/components/Table/Cells/DateCell'
import SimpleRiskChipCell from '@app/src/components/Table/Cells/SimpleRiskChipCell'
import type Assessment from '@app/src/types/assessment'
import type { RiskStatus } from '@app/src/types/resourceExplorer'
import { TableRow } from '@mui/material'
import React from 'react'

type AssessmentDialogRowProps = {
  row: Assessment
  riskStatus?: RiskStatus
  allAssessments: Assessment[]
  showTrendColumn?: boolean
}

export const AssessmentDialogRow = ({
  row: assessment,
  riskStatus,
  allAssessments,
  showTrendColumn = false,
}: AssessmentDialogRowProps): JSX.Element => {
  if (riskStatus)
    return (
      <TableRow>
        <CompanyCell company={assessment.provider} drawer />
        <AssessmentCell assessment={assessment} companyName={assessment.provider.name} />
        <CountryCell countryCode={assessment.provider.country?.countryCode} />
        <SimpleRiskChipCell riskStatus={riskStatus} />
        {showTrendColumn && <AssessmentTrendCell assessment={assessment} allAssessments={allAssessments} />}
      </TableRow>
    )

  return (
    <TableRow>
      <CompanyCell company={assessment.provider} drawer />
      <ChipCell label={assessment.periodName} />
      <AssessmentCell assessment={assessment} companyName={assessment.provider.name} />
      <DateCell value={assessment.updatedAt} />
      {showTrendColumn && <AssessmentTrendCell assessment={assessment} allAssessments={allAssessments} />}
    </TableRow>
  )
}

export default AssessmentDialogRow
